<div class="row action-toolbar">
    <div class="col-12">
        <form class="form-inline">
            <div class="form-group mr-3">
                <label for="lookupEquipment" class="mr-2">Equipment</label>
                <wj-combo-box
                    id="lookupEquipment"
                    name="lookupEquipment"
                    #equipmentCombo
                    [itemsSource]="equipmentOptions()"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                    [isEditable]="true"
                    [placeholder]="'Select equipment'"
                    style="width: 420px"
                    (initialized)="onEquipmentComboInitialized(equipmentCombo)"
                    (selectedValueChanged)="onEquipmentComboChange()"
                ></wj-combo-box>
            </div>
            <action-toolbar-count [grid]="grid"></action-toolbar-count>
            <action-toolbar-search name="equipmentLookupSearch" [(ngModel)]="grid.filter"></action-toolbar-search>
        </form>
    </div>
</div>
<div class="row">
    <div class="col-12">
        <wj-flex-grid
            id="byEquipmentGrid"
            #byEquipmentGrid
            appAutoSize
            (initialized)="grid.initialize(byEquipmentGrid)"
            (destroy)="grid.destroy()"
            [itemsSource]="grid.view"
        >
            <wj-flex-grid-filter></wj-flex-grid-filter>
            <wj-flex-grid-column [header]="'Source'" [binding]="'source'" [width]="100">
                <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                    <span class="pf-source-badge" [class.pf-source-vista]="cell.item.source === 'Vista'" [class.pf-source-webapps]="cell.item.source === 'WebApps'">
                        {{ cell.item.source }}
                    </span>
                </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Category'" [binding]="'category'" [width]="110"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Sub-Category'" [binding]="'subCategory'" [width]="140"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Item'" [binding]="'itemLabel'" [width]="140"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Value'" [binding]="'itemValue'" [width]="'*'">
                <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                    @if (cell.item.itemValue) {
                        <a
                            [routerLink]="['/equipment/parts-fluids-lookup']"
                            [queryParams]="{ tab: 'item', item: cell.item.itemValue }"
                            (click)="selectedItemChange.emit(cell.item.itemValue)"
                            >{{ cell.item.itemValue }}</a
                        >
                    }
                </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Qty'" [binding]="'quantity'" [width]="70"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Unit'" [binding]="'um'" [width]="70"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Details'" [binding]="'details'" [width]="'*'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Notes'" [binding]="'notes'" [width]="'*'"></wj-flex-grid-column>
        </wj-flex-grid>
    </div>
</div>
